import { formatNumber } from '@prophecy/utils/number';

export { formatNumber };

/** CU amounts are routinely fractions of a unit, so they need more precision than a general number. */
export function formatCredits(value: number): string {
  return formatNumber(value, 3);
}

export function toPercent(value: number, total: number): number {
  if (!total) return 0;
  return (value / total) * 100;
}

export function clampPercent(value: number): number {
  return Math.min(100, Math.max(0, value));
}

export function ratioAgainstMax(value: number, values: number[]): number {
  const max = Math.max(...values, 0);
  if (!max) return 0;
  return value / max;
}
